import { useRef, useEffect, useState, useCallback } from 'react';
import * as S from './styles';

// Componente que observa a altura dos children
const ObserverAltura = ({ children, onAlturaMudou, className, style, top = false }) => {
  const containerRef = useRef(null);
  const [alturaInterna, setAlturaInterna] = useState(0);

  // Callback para quando a altura mudar
  const tratarMudancaAltura = useCallback((novaAltura) => {
    setAlturaInterna(novaAltura);
    
    // Notificar o componente parent se a callback foi fornecida
    if (onAlturaMudou) {
      onAlturaMudou(novaAltura);
    }
  }, [onAlturaMudou]);

  useEffect(() => {
    const containerElement = containerRef.current;
    if (!containerElement) return;

    const observer = new ResizeObserver((entries) => {
      const novaAltura = entries[0].contentRect.height;
      
      // Só atualiza se a altura realmente mudou
      if (novaAltura !== alturaInterna) {
        tratarMudancaAltura(novaAltura);
      }
    });

    observer.observe(containerElement);

    // Cleanup
    return () => {
      observer.disconnect();
    };
  }, [alturaInterna, tratarMudancaAltura]);


  if (top) {return (
    <S.TopSheet 
      ref={containerRef}
      className={className}
      style={style}
    >
      {children}
    </S.TopSheet>
  );} else {
  return (
    <S.BottomSheet 
      ref={containerRef}
      className={className}
      style={style}
    >
      {children}
    </S.BottomSheet>
  );}
};

export default ObserverAltura;